import { toZonedTime } from 'date-fns-tz';

import { LocationListItem } from '../api/types';

// Resolve the IANA timezone the order's shifts are anchored to. This is
// the SAME resolution buildCreatePayload uses (location.timezone, else
// the browser tz as a last resort), so the client-admin "shift time
// cannot be in the past" check is evaluated against exactly the timezone
// the wire payload will be emitted in — V1 parity, where the legacy
// flow validated against `convertTZ(new Date(), address?.timezone)`.
//
// We intentionally re-derive this here (small, dependency-free) rather
// than importing buildCreatePayload's private `resolveTimezone`, and we
// do NOT touch any v1 component or graphql.
export const resolveJobTimezone = (
  locations: LocationListItem[],
  addressId: number | null | undefined,
): string => {
  const location =
    addressId != null
      ? locations.find((loc) => loc.id === addressId)
      : undefined;

  // Default timezone: America/New_York (Eastern)
  // Most jobs are in VA, FL, WA (Washington DC), and Puerto Rico
  // Using hardcoded EDT instead of browser timezone prevents DST calculation bugs
  // when user's browser timezone differs from job location.
  const DEFAULT_TIMEZONE = 'America/New_York';

  if (!location?.timezone) {
    console.debug(
      `[Order V2] No timezone for address ${addressId}, using default: ${DEFAULT_TIMEZONE}`,
    );
  }

  return location?.timezone || DEFAULT_TIMEZONE;
};

// "Now" as a Date whose LOCAL getters (getFullYear/getMonth/getDate/
// getHours/getMinutes) read the wall-clock time in `timezone`. This is
// the robust equivalent of v1's `convertTZ(new Date(), tz)` — used so
// the same-day past-time comparison is independent of the browser/host
// timezone and only depends on the job location's timezone.
export const nowInTimezone = (timezone: string): Date =>
  toZonedTime(new Date(), timezone);
